import partnerJSON from './partner.json'

let lang = {}
export default lang
export let langId = 'en'

export function setLang(id) {
	if (id && partnerJSON.partnerLang[id]) {
		id = id.toLowerCase()
		Object.assign(lang, partnerJSON.partnerLang[id])
		langId = id
		localStorage.resqLangId = id
	} else {
		if (localStorage.resqLangId) {
			setLang(localStorage.resqLangId)
			return
		}

		const language = window.navigator.userLanguage || window.navigator.language || 'en'
		// Browsers set the language as en-US foe example, and we only need the first two characters
		setLang(language.substring(0,2))
	}
}

export function getLanguageIds() {
	return Object.keys(partnerJSON.partnerLang).sort()
}
